module.exports = __webpack_public_path__ + "static/media/chevron-down.fb2f5f06.svg";